import React, { FC, useContext, useEffect, useState } from 'react';

import { navigate } from '@reach/router';

import { GlobalContext } from '../../../../store';

import Button from '../../../../components/Button';
import { Modal } from '../../../../components/Modal';
import Stepper from '../../../../components/Stepper';
import { IStep } from '../../../../components/Stepper/Stepper';
import { useBoolean } from '../../../common/Hooks/useBoolean.hook';
import { useFormattedAwards } from '../Common/AssignAwardsTable/Hooks/useFormattedAwards.hook';
import { EventWizardStepTitle } from '../Components/EventWizardStepTitle/EventWizardStepTitle';
import { AssignEventAwardsStep } from './Components/AssignEventAwardsStep';
import CompleteEventStep from './Components/CompleteEventStep';
import { useRouteInfoState } from '../../../../components/RouteInfo/Context/RouteInfo.context';

const CompleteEvents: FC = () => {
  const { clubId, eventId } = useRouteInfoState();

  const {
    actions: {
      adminEventAwards: { get: getEventAwards },
      adminEvents: { edit: editEvent }
    },
    adminEventAwards
  } = useContext(GlobalContext);

  useEffect(() => {
    getEventAwards(clubId, eventId);
  }, [clubId, eventId]);

  const [awards] = useFormattedAwards(Number(eventId), adminEventAwards);

  const [activeStep, setActiveStep] = useState(1);

  const [open, , toggleOpenDialog] = useBoolean(false);
  const [resultsStepState, setResultsStepState] = useState<'' | 'done'>('');

  const skipNContinue = () => {
    if (activeStep === 0) {
      setResultsStepState('done');
      setActiveStep(1);
    } else {
      navigate(`/staff/club/${clubId}/events`);
    }
  };

  const onContinueClick = () => {
    activeStep === 0 ? setActiveStep(1) : onCompleteEvent();
  };

  const onCompleteEvent = async () => {
    await editEvent(Number(clubId), { id: Number(eventId), status: 'completed' });

    toggleOpenDialog();
  };

  const onSetActiveStep = (_: any, step: number) => {
    setActiveStep(step);
  };

  interface IExtendedStep extends IStep {
    content: JSX.Element;
    height: number;
    title: string;
  }

  const steps: IExtendedStep[] = [
    {
      content: <AssignEventAwardsStep awards={awards} />,
      height: 1,
      name: 'Results',
      status: resultsStepState,
      title: ''
    },
    {
      content: <CompleteEventStep />,
      height: 1,
      name: 'Wrap up',
      status: '',
      title: 'Wrap up'
    }
  ];

  return (
    <>
      <Stepper steps={steps} active={activeStep} onChange={onSetActiveStep} />

      <div className="admin-wrapper">
        <div className="event-wizard-page round-setup ">
          <div className="complete-event">
            <EventWizardStepTitle
              buttonText={activeStep === 0 ? 'CONTINUE' : 'COMPLETE EVENT'}
              buttonOnClick={onContinueClick}
              title={steps[activeStep].title.toUpperCase()}
            />

            <div className="assign-awards">{steps[activeStep].content}</div>
          </div>
        </div>

        <Modal
          onClose={toggleOpenDialog}
          open={open}
          className="select-dialog"
          title="EVENT COMPLETED"
          actions={[
            <Button
              key="button-remove-ok"
              fullWidth={true}
              onClick={skipNContinue}
              variant="contained"
              className="confirm-removal-button"
              color="primary"
            >
              CONTINUE
            </Button>
          ]}
        />
      </div>
    </>
  );
};

export default CompleteEvents;
